// NavigationDrawer : Right positioned for App Settings
// @group DefaultLayout
export default {
    props: {
        value: {
            type: Boolean
        },
    },
    data() {
        return {
            rightDrawer: {
                // sets the open status of the drawer
                show        : this.value,
            },
        };
    },
    computed: {
        themeOption : {
            get: function () {
                if (localStorage.getItem('userThemeDark') == 'true') {
                    return 'dark';
                } else {
                    return 'light';
                }
            },
            // setter
            set: function (val) {
                if (val) {
                    if (val === 'dark') {
                        localStorage.setItem('userThemeDark', true);
                        this.$vuetify.theme.dark = true;
                    } else {
                        localStorage.setItem('userThemeDark', false);
                        this.$vuetify.theme.dark = false;
                    }
                } else {
                    return;
                }
            }
        },
        i18nBarOption :  {
            get: function () {
                return localStorage.getItem('userLanguage');
            },
            // setter
            set: function (lang) {
                if (!lang) {
                    return;
                }
                this.$root.$i18n.locale = lang;
                localStorage.setItem('userLanguage', lang);
                switch(lang) {
                    case 'de':
                        this.$moment.locale('de-ch');
                        break;
                    case 'en':
                        this.$moment.locale('en-gb');
                        break;
                    case 'fr':
                        this.$moment.locale('fr');
                        break;
                    case 'it':
                        this.$moment.locale('it');
                        break;

                    default:
                        this.$moment.locale('de-ch');
                    }
            }
        },
        jsonDebug : {
            get: function () {
                if (localStorage.getItem('userDeveloperModus') == 'true') {
                    return true;
                } else {
                    return false;
                }
            },
            // setter
            set: function (val) {
                if (val) {
                    localStorage.setItem('userDeveloperModus', true);
                } else {
                    localStorage.setItem('userDeveloperModus', false);
                }
            }
        },
    },
    watch: {
        value: function(val) {
            this.rightDrawer.show = !this.rightDrawer.show;
        },
    }
};

